/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".handleerror-img{width:100%;height:17vmin;background-color:#fff;-o-object-fit:cover;object-fit:cover}.contain-image{background-color:#fff;-o-object-fit:contain!important;object-fit:contain!important}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image/image.component.scss.ngstyle.js.pre-build-optimizer.js